import React from 'react'

const Servicos = props => {
    return(
        <div style={{ marginTop: -30 }}>

        {/* Container (Services Section) */}
        <div id='services' className='container-fluid text-center'>
                <h2>SERVIÇOS</h2>
                <h4>O que fazemos</h4>
                <br />
                <div className='row '>
                    <div className='col-sm-4'>
                        <span className='glyphicon glyphicon-off logo-small'></span>
                        <h4>POWER</h4>
                        <p>Lorem ipsum dolor sit amet..</p>
                    </div>
                    <div className='col-sm-4'>
                        <span className='glyphicon glyphicon-heart logo-small'></span>
                        <h4>LOVE</h4>
                        <p>Lorem ipsum dolor sit amet..</p>
                    </div>
                    <div className='col-sm-4'>
                        <span className='glyphicon glyphicon-lock logo-small'></span>
                        <h4>JOB DONE</h4>
                        <p>Lorem ipsum dolor sit amet..</p>
                    </div>
                </div>
                <br /><br />
                <div className='row '>
                    <div className='col-sm-4'>
                        <span className='glyphicon glyphicon-leaf logo-small'></span>
                        <h4>GREEN</h4>
                        <p>Lorem ipsum dolor sit amet..</p>
                    </div>
                    <div className='col-sm-4'>
                        <span className='glyphicon glyphicon-certificate logo-small'></span>
                        <h4>CERTIFIED</h4>
                        <p>Lorem ipsum dolor sit amet..</p>
                    </div>
                    <div className='col-sm-4'>
                        <span className='glyphicon glyphicon-wrench logo-small'></span>
                        <h4>HARD WORK</h4>
                        <p>Lorem ipsum dolor sit amet..</p>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Servicos